import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {zodResolver} from '@hookform/resolvers/zod';
import defaultIcon from "../../../assets/images/deafult/default-small-image.png";
import Tinymce from "../../../components/tinymce";
import ErrorMessage from "../../../components/ErrorMessage";
import useServices from "../../../hooks/admin/useServices";
import PageLoader from "../../../components/pageLoader";
import {useNavigate} from "react-router-dom";

const ServiceCreatePage = () => {
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(defaultIcon);
  const [imageTag, setImageTag] = useState("Iocn");

  const {isLoading, error, schema, create} = useServices();

  const {register, handleSubmit, formState: {errors}, setValue} = useForm({
    resolver: zodResolver(schema)
  });

  const handleChangeIcon = (event) => {
    const file = event.target.files[0];
    setValue("image", file);

    setImageTag(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (data) => {
    const {image, name, settlementTime, applicationFee} = data;

    const formData = new FormData();
    formData.append("image", image);
    formData.append("name", name);
    formData.append("workProcedure", editorRefWorkProcedure.current.getContent());
    formData.append("necessaryDoc", editorRefNecessaryDoc.current.getContent());
    formData.append("settlementTime", settlementTime);
    formData.append("applicationFee", applicationFee);

    const result = create(formData);
    if (result) {
      setTimeout(() => {
        navigate("/admin/services");
      }, 1000);
    }
  };

  const editorRefNecessaryDoc = React.useRef(null);
  const editorRefWorkProcedure = React.useRef(null);

  if (isLoading) return <PageLoader/>;
  if (error) return null;
  return (
      <div className="services-update-section">
        <div className="custom-container">
          <div className="content-section">
            <h1 className="page-title">Create Service</h1>
            <div className="content-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-xl-12 form__div-container">
                    <div className="service-image-container">
                      <img
                          className="service-icon"
                          src={imagePreview}
                          alt={imageTag}
                      />
                      <div className="image-uploader">
                        <label className="icon-update-btn" htmlFor="uploader">
                          <i className="fa fa-pencil"></i>
                        </label>
                        <input
                            id='uploader'
                            className="d-none"
                            type="file"
                            accept="image/jpg, image/jpeg, image/png, image/webp"
                            {...register("image", {onChange: handleChangeIcon})}
                        />
                      </div>
                    </div>
                    <ErrorMessage message={errors.image?.message}/>
                  </div>
                  <div className="col-xl-12 form__div-container">
                    <div className="form__div">
                      <input
                          type="text"
                          className="form__input"
                          {...register("name")}
                      />
                      <label htmlFor="name" className="form__label">
                        Service Name
                      </label>
                    </div>
                    <ErrorMessage message={errors.name?.message}/>
                  </div>
                  <div className="col-xl-12 form__div-container">
                    <h5>Necessary Documents</h5>
                    <Tinymce
                        editorRef={editorRefNecessaryDoc}
                        onEditorChange={(content) => setValue("necessaryDoc", content)}
                    />
                    <ErrorMessage message={errors.necessaryDoc?.message}/>
                  </div>
                  <div className="col-xl-12 form__div-container">
                    <h5>Work Procedure</h5>
                    <Tinymce
                        editorRef={editorRefWorkProcedure}
                        onEditorChange={(content) => setValue("workProcedure", content)}
                    />
                    <ErrorMessage message={errors.workProcedure?.message}/>
                  </div>
                  <div className="col-xl-6 form__div-container">
                    <div className="form__div">
                      <input
                          type="text"
                          className="form__input"
                          {...register("settlementTime")}
                      />
                      <label htmlFor="settlementTime" className="form__label">
                        Time of Settlement
                      </label>
                    </div>
                    <ErrorMessage message={errors.settlementTime?.message}/>
                  </div>
                  <div className="col-xl-6 form__div-container">
                    <div className="form__div">
                      <input
                          type="text"
                          className="form__input"
                          {...register("applicationFee")}
                      />
                      <label htmlFor="applicationFee" className="form__label">
                        Application Fee
                      </label>
                    </div>
                    <ErrorMessage message={errors.applicationFee?.message}/>
                  </div>
                  <div className="col-xl-12 text-right">
                    <button type='submit' className="save-btn">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ServiceCreatePage;
